import axios from "axios";
import { saveAs } from 'file-saver';
import {GET_MATERIALS, SET_MATERIALS_LOADING, GET_MATERIALS_FAIL, CLEAR_MATERIALS,
    POST_MATERIAL, POST_MATERIAL_SET_LOADING, POST_MATERIAL_SUCCESS, POST_MATERIAL_FAIL,
    GET_PERSONEL, SET_PERSONEL_LOADING, GET_PERSONEL_FAIL, CLEAR_PERSONEL,
    POST_PERSONEL_FAIL, POST_PERSONEL_SUCCESS, POST_PERSONEL_SET_LOADING, POST_PERSONEL,
    CLEAR_NUMER_OPK_PROC, GET_NUMER_OPK_PROC_FAIL, SET_NUMER_OPK_PROC_LOADING, GET_NUMER_OPK_PROC,
    CLEAR_NUMER_OPK_PROC507, GET_NUMER_OPK_PROC_FAIL507, SET_NUMER_OPK_PROC_LOADING507, GET_NUMER_OPK_PROC507,
    CLEAR_CATEGORY_PERSONEL, GET_CATEGORY_PERSONEL_FAIL, SET_CATEGORY_PERSONEL_LOADING, GET_CATEGORY_PERSONEL,
    CLEAR_PROCEDURE, GET_PROCEDURE_FAIL, SET_PROCEDURE_LOADING, GET_PROCEDURE,
    CLEAR_ICD9, GET_ICD9_FAIL, SET_ICD9_LOADING, GET_ICD9,
    POST_PROCEDURA, POST_PROCEDURA_SET_LOADING, POST_PROCEDURA_SUCCESS, POST_PROCEDURA_FAIL,
    GET_MATERIAL_TEMPLATE, POST_MATERIAL_FILE, POST_MATERIAL_FILE_LOADING, POST_MATERIAL_FILE_FAIL,
    GET_PERSONEL_TEMPLATE, POST_PERSONEL_FILE, POST_PERSONEL_FILE_LOADING, POST_PERSONEL_FILE_FAIL,
    DELETE_PROCEDURA_FAIL, DELETE_PROCEDURA_SUCCESS} from '../actions/types'

import { refreshUser } from './authActions'
import {
    GET_MATERIAL_TYPE,
    GET_MATERIAL_TYPE_ERROR, GET_UNIT_TYPE, GET_UNIT_TYPE_ERROR, POST_AVAILABLE_PERSONEL,
    POST_MATERIAL_TYPE,
    POST_MATERIAL_TYPE_ERROR, POST_UNIT_TYPE,
    POST_UNIT_TYPE_ERROR,
    TYPE_LOADING
} from "./actions";
import {
    CLEAR_ERROR_MATERIALS,
    DELETE__MATERIAL_FAIL,
    DELETE_MATERIAL_SUCCESS,
    DELETE_PERSONEL_FAIL,
    DELETE_PERSONEL_SUCCESS,
    EDIT_MATERIAL_FAIL,
    EDIT_MATERIAL_SET_LOADING,
    EDIT_MATERIAL_SUCCESS,
    EDIT_PERSONEL_FAIL,
    EDIT_PERSONEL_SET_LOADING,
    EDIT_PERSONEL_SUCCESS
} from "./types";
//pobieranie raportu getReport[numer], pobieranie od kodu do rozwijania getCode[numer]
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`
}
export const getMaterials =(params)=>async dispatch => {
    dispatch({type: CLEAR_MATERIALS})
    dispatch({ type: SET_MATERIALS_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/material/select_material/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET_MATERIALS,
          payload: response.data
        });
    
      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_MATERIALS_FAIL,
        });
      }
    }

export const postMaterial = (formData) => async (dispatch) => {
    dispatch({
        type: POST_MATERIAL_SET_LOADING,
    });
    
    const config = {
        method: 'post',
        url: `/api/material/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);
    
        dispatch({
        type: POST_MATERIAL_SUCCESS,
        payload: response.data
        });
    
        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: POST_MATERIAL_FAIL,
        payload: errors.msg
        });
    }
    }

export const getPersonel =(params)=>async dispatch => {
    dispatch({type: CLEAR_PERSONEL})
    dispatch({ type: SET_PERSONEL_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/procedure_staff/select_procedurestaffcalc/`,
        params: params,
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
        const response = await axios(config);
        dispatch({
            type: GET_PERSONEL,
            payload: response.data
        });
    
        }catch (err) {
            console.log("error: ", JSON.stringify(err))
            refreshUser()
            dispatch({
                type: GET_PERSONEL_FAIL,
            });
        }
    }

export const postPersonel = (formData) => async (dispatch) => {
    dispatch({
        type: POST_PERSONEL_SET_LOADING,
    });
    
    const config = {
        method: 'post',
        url: `/api/procedure_staff/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);
    
        dispatch({
        type: POST_PERSONEL_SUCCESS,
        payload: response.data
        });
    
        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: POST_PERSONEL_FAIL,
        payload: errors.msg
        });
    }
    }
//OPK PROC
export const getProcedOPK =(params)=>async dispatch => {
    dispatch({type: CLEAR_NUMER_OPK_PROC})
    dispatch({ type: SET_NUMER_OPK_PROC_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/opk/filter_507_name_number/`,
        params: params,
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
        const response = await axios(config);
        dispatch({
            type: GET_NUMER_OPK_PROC,
            payload: response.data
        });
    
        }catch (err) {
            console.log("error: ", JSON.stringify(err))
            refreshUser()
            dispatch({
                type: GET_NUMER_OPK_PROC_FAIL,
            });
        }
    }
    ///opk dla procedur
export const getOPK507 =(params)=>async dispatch => {
    dispatch({type: CLEAR_NUMER_OPK_PROC507})
    dispatch({ type: SET_NUMER_OPK_PROC_LOADING507 })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/opk/filter_507_name_number/`,
        params: {base_opk:false},
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
        const response = await axios(config);
        dispatch({
            type: GET_NUMER_OPK_PROC507,
            payload: response.data
        });
    
        }catch (err) {
            console.log("error: ", JSON.stringify(err))
            refreshUser()
            dispatch({
                type: GET_NUMER_OPK_PROC_FAIL507,
            });
        }
    }
//personel category
export const getPersonelCategory =(params)=>async dispatch => {
    dispatch({type: CLEAR_CATEGORY_PERSONEL})
    dispatch({ type: SET_CATEGORY_PERSONEL_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/procedure_personel/`,
        params: params,
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
        const response = await axios(config);
        dispatch({
            type: GET_CATEGORY_PERSONEL,
            payload: response.data
        });
    
        }catch (err) {
            console.log("error: ", JSON.stringify(err))
            refreshUser()
            dispatch({
                type: GET_CATEGORY_PERSONEL_FAIL,
            });
        }
    }
    //get procedures
export const getProcedures =(params)=>async dispatch => {
    dispatch({type: CLEAR_PROCEDURE})
    dispatch({ type: SET_PROCEDURE_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/procedure/`,
        params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
        const response = await axios(config);
        dispatch({
        type: GET_PROCEDURE,
        payload: response.data
        });
    
    }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
        type: GET_PROCEDURE_FAIL,
        });
    }
    }
    //icd9 dla posta na procedure
export const getICD9 =(params)=>async dispatch => {
    dispatch({type: CLEAR_ICD9})
    dispatch({ type: SET_ICD9_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/icd9slownik/`,
        params: params,
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
        const response = await axios(config);
        dispatch({
            type: GET_ICD9,
            payload: response.data
        });
    
        }catch (err) {
            console.log("error: ", JSON.stringify(err))
            refreshUser()
            dispatch({
                type: GET_ICD9_FAIL,
            });
        }
    }

    //post procedura

export const postProcedura = (formData) => async (dispatch) => {
        dispatch({
            type: POST_PROCEDURA_SET_LOADING,
        });
        
        const config = {
            method: 'post',
            url: `/api/procedure/`,
            data: formData,
            headers: {
            'Content-Type': 'application/json',
            },
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
    
        try {
            const response = await axios(config);
        
            dispatch({
            type: POST_PROCEDURA_SUCCESS,
            payload: response.data
            });
        
            // dispatch(
            //   loadUser()
            // )
        } catch (err) {
            const errors = {
            msg: err.response.data,
            status: err.response.status,
            };
            dispatch({
            type: POST_PROCEDURA_FAIL,
            payload: errors.msg
            });
        }
        }
    //usuwanie procedury
    export const deleteProcedura = (id) => async (dispatch) => {

        const config = {
            method: 'delete',
            url: `/api/procedure/`+id+'/',
            headers: {
            'Content-Type': 'application/json',
            },
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
    
        try {
            const response = await axios(config);
    
    
            dispatch({
            type: DELETE_PROCEDURA_SUCCESS,
            payload: id
            });
    
            // dispatch(
            //   loadUser()
            // )
        } catch (err) {
            const errors = {
            msg: err.response.data,
            status: err.response.status,
            };
            dispatch({
            type: DELETE_PROCEDURA_FAIL,
            payload: errors.msg
            });
        }
        }
    ///



export const getMaterialTypes =(params)=>async dispatch => {

    const config = {
        headers: headers,
        method: "get",
        url: `/api/material_type/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET_MATERIAL_TYPE,
          payload: response.data
        });

      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_MATERIAL_TYPE_ERROR,
        });
      }
    }

export const postMaterialType = (formData) => async (dispatch) => {
    dispatch({
        type: TYPE_LOADING,
    });
    const config = {
        method: 'post',
        url: `/api/material_type/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: POST_MATERIAL_TYPE,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: POST_MATERIAL_TYPE_ERROR,
        payload: errors.msg
        });
    }
}
export const getUnitTypes =(params)=>async dispatch => {

    const config = {
        headers: headers,
        method: "get",
        url: `/api/unit_type/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET_UNIT_TYPE,
          payload: response.data
        });

      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_UNIT_TYPE_ERROR,
        });
      }
    }

export const postUnitType = (formData) => async (dispatch) => {
    dispatch({
        type: TYPE_LOADING,
    });
    const config = {
        method: 'post',
        url: `/api/unit_type/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: POST_UNIT_TYPE,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: POST_UNIT_TYPE_ERROR,
        payload: errors.msg
        });
    }
}


export const postAvailablePersonel = (formData) => async (dispatch) => {

    const config = {
        method: 'post',
        url: `/api/procedure_personel/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: POST_AVAILABLE_PERSONEL,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        let POST_AVAILABLE_PERSONEL_ERROR;
        dispatch({
        type: POST_AVAILABLE_PERSONEL_ERROR,
        payload: errors.msg
        });
    }
}
export const clearErrorPostMaterial = () => async (dispatch) => {
        dispatch({
        type: CLEAR_ERROR_MATERIALS,
        });

}


export const editMaterial = (formData,id) => async (dispatch) => {
    dispatch({
        type: EDIT_MATERIAL_SET_LOADING,
    });

    const config = {
        method: 'put',
        url: `/api/material/`+id+'/',
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: EDIT_MATERIAL_SUCCESS,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: EDIT_MATERIAL_FAIL,
        payload: errors.msg
        });
    }
    }

export const deleteMaterial = (id) => async (dispatch) => {

    const config = {
        method: 'delete',
        url: `/api/material/`+id+'/',
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);


        dispatch({
        type: DELETE_MATERIAL_SUCCESS,
        payload: id
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: DELETE__MATERIAL_FAIL,
        payload: errors.msg
        });
    }
    }


export const editPersonel = (formData,id) => async (dispatch) => {
    dispatch({
        type: EDIT_PERSONEL_SET_LOADING,
    });

    const config = {
        method: 'put',
        url: `/api/procedure_staff/`+id+'/',
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: EDIT_PERSONEL_SUCCESS,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: EDIT_PERSONEL_FAIL,
        payload: errors.msg
        });
    }
    }

export const deletePersonel = (id) => async (dispatch) => {
    const config = {
        method: 'delete',
        url: `/api/procedure_staff/`+id+'/',
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: DELETE_PERSONEL_SUCCESS,
        payload: id
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: DELETE_PERSONEL_FAIL,
        payload: errors.msg
        });
    }
    }
    //templatka materiały
    export const getTemplateExcelMaterial = () => async (dispatch) => {
        const config = {
            method: "get",
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            url:"/api/get_template_materialy"
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const res = await axios(config);
            let blob = new Blob([res.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
            saveAs(blob, 'PLIK DO WPROWADZANIA ZASOBÓW MATERIAŁOWYCH PRZEZ ŚWIADCZENIODAWCÓW.xlsx');
            dispatch({
                type: GET_MATERIAL_TEMPLATE,
                payload: res.data})
            } catch (err) {
                console.log("error: ", JSON.stringify(err))
            }
    };
    ///wysyłanie pliku materiały
    export const uploadFileMaterial = (xlsxFile) => async (dispatch) => {
        dispatch({type: POST_MATERIAL_FILE_LOADING})
        const config = {
            method: 'post',
            data:xlsxFile,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            url:'/api/materialupload/'
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const response = await axios(config);
            dispatch({
                type: POST_MATERIAL_FILE,
                payload: response.data
            })
        } catch (err) {
            console.log("error: ", JSON.stringify(err))
            dispatch({
                type: POST_MATERIAL_FILE_FAIL,
                error: err.response?err.response.data:true
            })
        }
    }
    ///tempalatka xls do personelu
    export const getTemplateExcelPersonel = () => async (dispatch) => {
        const config = {
            method: "get",
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            url:"/api/get_template_osobowe"
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const res = await axios(config);
            let blob = new Blob([res.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
            saveAs(blob, 'PLIK DO WPROWADZANIA ZASOBÓW OSOBOWYCH PRZEZ ŚWIADCZENIODAWCÓW.xlsx');
            dispatch({
                type: GET_MATERIAL_TEMPLATE,
                payload: res.data})
            } catch (err) {
                console.log("error: ", JSON.stringify(err))
            }
    };
    /// upload plików personel
    export const uploadFilePersonel = (xlsxFile) => async (dispatch) => {
        dispatch({type: POST_MATERIAL_FILE_LOADING})
        const config = {
            method: 'post',
            data:xlsxFile,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            url:'/api/staffupload/'
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const response = await axios(config);
            dispatch({
                type: POST_MATERIAL_FILE,
                payload: response.data
            })
        } catch (err) {
            console.log("error: ", JSON.stringify(err))
            dispatch({
                type: POST_MATERIAL_FILE_FAIL,
                error: err.response?err.response.data:true
            })
        }
    }
    //templatka xls dla procedur
    export const getTemplateExcelProcedury = () => async (dispatch) => {
        const config = {
            method: "get",
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            url:"/api/get_template_procedury"
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const res = await axios(config);
            let blob = new Blob([res.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
            saveAs(blob, 'PLIK DO WPROWADZANIA REALIZOWANYCH PROCEDUR PRZEZ ŚWIADCZENIODAWCÓW.xlsx');
            dispatch({
                type: GET_MATERIAL_TEMPLATE,
                payload: res.data})
            } catch (err) {
                console.log("error: ", JSON.stringify(err))
            }
    };
    //upload plików procedury
    export const uploadFileProcedury = (xlsxFile) => async (dispatch) => {
        dispatch({type: POST_MATERIAL_FILE_LOADING})
        const config = {
            method: 'post',
            data:xlsxFile,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            url:'/api/procedureupload/'
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
            const response = await axios(config);
            dispatch({
                type: POST_MATERIAL_FILE,
                payload: response.data
            })
        } catch (err) {
            console.log("error: ", JSON.stringify(err))
            dispatch({
                type: POST_MATERIAL_FILE_FAIL,
                error: err.response?err.response.data:true
            })
        }
    }
